const inputs = new WeakMap();

const argMap = {
  'png': 'image/png',
  'gif': 'image/gif',
  'jpeg': 'image/jpeg'
}

export default {
  install(Vue) {
    Vue.directive('file-upload', {
      bind(el, binding) {
        const input = document.createElement('input');
        const bindingArgs = (binding.arg) ? binding.arg.split(',') : null;
        let fileTypes = null;
        input.type = 'file';

        if(bindingArgs) {
          fileTypes = bindingArgs.map((arg) => argMap[arg]).join(',');
          input.accept = fileTypes;
        }

        input.onchange = event => {
          const file = event.target.files[0];
          let error = null;
          if(!fileTypes.includes(file.type)){
            error = new Error(`file extension not allowed. please upload ${bindingArgs.join(", ")}`)
          }else if(file.size > 10 * 1024 * 1024) {
            error = new Error('Uploading image file size must be less than 10MB');
          }
          binding.value(file, error);
        }

        el.addEventListener('click', () => {
          input.click();
        });

        inputs.set(el, input);
      },
      unbind(el) {
        const input = inputs.get(el);
        input.remove();
        inputs.delete(el);
      }
    })
  }
}
